import type { FC } from 'react'

import { Input, Card } from '@skytech/ui'
import type { FieldProps } from 'formik'
import { Field } from 'formik'

import { Translation } from '@/app/translations/Translation'

const Amounts: FC = () => (
  <Card className="amount-limits">
    <h3>
      <Translation id="Amount limits" />
    </h3>

    <Field name="minimumAmount">
      {({ field, meta }: FieldProps) => (
        <Input
          isFullWidth
          id="minimumAmount"
          label={<Translation id="Split down payment limit" />}
          type="number"
          error={meta.error}
          touched={meta.touched}
          {...field}
        />
      )}
    </Field>

    <Field name="coverAmount">
      {({ field, meta }: FieldProps) => (
        <Input
          isFullWidth
          id="coverAmount"
          type="number"
          label={<Translation id="Max amount covered by company" />}
          error={meta.error}
          touched={meta.touched}
          {...field}
        />
      )}
    </Field>

    <Field name="coverAmountInit">
      {({ field, meta }: FieldProps) => (
        <Input
          isFullWidth
          id="coverAmountInit"
          type="number"
          label={<Translation id="Max amount covered by company on the first order" />}
          error={meta.error}
          touched={meta.touched}
          {...field}
        />
      )}
    </Field>

    <Field name="maximumAmount">
      {({ field, meta }: FieldProps) => (
        <Input
          isFullWidth
          id="maximumAmount"
          type="number"
          label={<Translation id="Maximum order cost" />}
          error={meta.error}
          touched={meta.touched}
          {...field}
        />
      )}
    </Field>
  </Card>
)

export default Amounts
